import React, { useEffect, useState } from "react";
import "./slideCompanies.scss";

//Imagens:
import logoClaro from "../../../../assets/homeImgs/logoCompanies/logoClaro.png";
import logoDufry from "../../../../assets/homeImgs/logoCompanies/logoDufry.png";
import logoEtna from "../../../../assets/homeImgs/logoCompanies/logoEtna.png";
import logoGrupoDpsp from "../../../../assets/homeImgs/logoCompanies/logoGrupoDpsp.png";
import logoLeroyMerlin from "../../../../assets/homeImgs/logoCompanies/logoLeroyMerlin.png";
import logoNeon from "../../../../assets/homeImgs/logoCompanies/logoNeon.png";
import logoPortoSeguro from "../../../../assets/homeImgs/logoCompanies/logoPortoSeguro.png";
import logoVivo from "../../../../assets/homeImgs/logoCompanies/logoVivo.png";
import slideUm from "../../../../assets/homeImgs/logoCompanies/imgDeskUm.png";
import slideDois from "../../../../assets/homeImgs/logoCompanies/imgDeskDois.png";
import slideTres from "../../../../assets/homeImgs/logoCompanies/imgDeskTres.png";

const SlideCompanies = () => {

const [images] = useState([
  logoClaro,
  logoDufry,
  logoEtna,
  logoGrupoDpsp,
  logoLeroyMerlin,
  logoNeon,
  logoPortoSeguro,
  logoVivo,
]);
const [imgIndex, setimgIndex] = useState(0);
const [imagesDesk] = useState([
  slideUm,
  slideDois,
  slideTres
]);
const [imgIndexDesk, setimgIndexDesk] = useState(0);


let width = window.innerWidth;
useEffect(() => {
  if(width >= 768){
    const lastIndexDesk = imagesDesk.length - 1;
    if(imgIndexDesk < 0){
      setimgIndexDesk(lastIndexDesk);
    } 
    if(imgIndexDesk > lastIndexDesk){
      setimgIndexDesk(0);
    }
  }
  const lastIndex = images.length - 1;
  if(imgIndex < 0){
    setimgIndex(lastIndex);
  } 
  if(imgIndex > lastIndex){
    setimgIndex(0);
  }
}, [imgIndex, imgIndexDesk, images, imagesDesk]);

useEffect(() => {
  if(width >= 768){
    let sliderDesk = setInterval(() => {
      setimgIndexDesk(imgIndexDesk + 1);
    }, 5000);
    return () => clearInterval(sliderDesk);
  } else {
    let slider = setInterval(() => {
      setimgIndex(imgIndex + 1);
    }, 5000);
    return () => clearInterval(slider);
  }
}, [imgIndex, imgIndexDesk]);

  return (
    <div className="container-slide-companies">
      {
        width >= 768 ? (<img src={imagesDesk[imgIndexDesk]} className="sliderimg"
        style={{width: "70%", height: "100%"}}
        />) : (<img src={images[imgIndex]} className="sliderimg"
        
        />)
      }
    </div>
  );
};
export default SlideCompanies;